export const getFacetsWithSelectedOptions = (facets: ProductFilter[], selectedFilters: SelectedProductFilters) => {
  if (!facets) {
    return []
  }
  return facets.map((facet) => {
    facet.options.forEach((facetOption) => {
      if (!selectedFilters[facetOption.attrName]) {
        facetOption.selected = false
        facetOption.value = facetOption.id
      } else if (selectedFilters?.[facetOption.attrName]) {
        if (REGEX_RANGE_FORMAT.exec(facetOption.id)) {
          const filterValue = selectedFilters[facetOption.attrName]
          facetOption.value =
            filterValue &&
            (Array.isArray(filterValue) ? (filterValue.length ? filterValue[0] : facetOption.id) : filterValue)
        } else {
          facetOption.selected = selectedFilters[facetOption.attrName].includes(facetOption.id)
        }
      }
    })

    return facet
  })
}

export const getMinMaxFromRangeFormat = (regexRangeFormat: string[]): number[] => {
  let optionRangeIdNumber: number[] = []
  if (regexRangeFormat?.length === 3) {
    // index 0 is the initial range string eg '(0..49999)'
    regexRangeFormat.shift()
    optionRangeIdNumber = regexRangeFormat.map(Number)
  }
  return optionRangeIdNumber
}

export const formatPriceFilter = (priceValue: string, isFRCA?: boolean) => {
  const matches = REGEX_RANGE_FORMAT.exec(priceValue)
  if (matches && matches.length === 3) {
    const min = parseInt(matches[1], 10)
    const max = parseInt(matches[2], 10)

    if (max >= 99999) {
      return !isFRCA ? `$${min}+` : `${min}+ $`
    }

    return !isFRCA ? `$${min} - $${max}` : `${min} $ - ${max} $`
  }
  return priceValue
}
